import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import {
    AllocationOverviewConfirmationCheck,
    Overview,
    SimulationOverview,
    MissingPartDetails,
    BookClosureDetails,
} from "src/state/overview/state-models/overview-data";
import { Apollo, gql } from "apollo-angular";

@Injectable({
    providedIn: "root",
})
export class OverviewApiService {
    constructor(
        private http: HttpClient,
        private apollo: Apollo,
    ) {}

    GetByAllocationType(allocationType: number): Observable<Overview[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/byAllocationType`;
        return this.http.get<Overview[]>(url, {
            params: { allocationType: allocationType.toString() },
        });
    }

    GetSimulation(): Observable<SimulationOverview> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/bySimulation`;
        return this.http.get<SimulationOverview>(url);
    }
    GetBookClosureDetail(): Observable<BookClosureDetails> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/GetBookClosureDate`;
        return this.http.get<BookClosureDetails>(url);
    }

    GetSimulationMissingPart(
        from: string,
        to: string,
        marketId: number,
        slaMarketId: number,
    ): Observable<MissingPartDetails> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/bySimulationMissingPart`;
        const reqData = {
            FromDate: from,
            ToDate: to,
            MarketId: marketId,
            SlaMarketId: slaMarketId,
        };
        return this.http.get<MissingPartDetails>(url, { params: reqData });
    }

    SaveAllocationOverviewConfirmationCheck(
        payload: AllocationOverviewConfirmationCheck,
    ) {
        const mutation = `
        mutation saveAllocationOverviewConfirmationCheck($payload: AllocationOverviewConfirmationCheckInput!){
            allocationOverviewConfirmationCheck{
                saveAllocationOverviewConfirmationCheck(payload: $payload)
                {
                    scaniaUnitId
                    updatedBy
                    isCompleted
                }
            }
        }`;
        return this.apollo
            .mutate({
                mutation: gql(mutation),
                variables: { payload },
            })
            .toPromise();
    }
}
